import { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useSite } from "@/context/SiteContext";
import { PageHero, Prose } from "@/components/common";
import useTitle from "@/lib/useTitle";

export default function Info() {
  useTitle("Informações úteis");
  const { data } = useSite();
  const { hash } = useLocation();
  const pages = data.pages.filter((p) => p.group === "info");
  const faqs = data.resources.filter((r) => r.type === "faq");
  useEffect(() => { if (hash) setTimeout(() => document.querySelector(hash)?.scrollIntoView({ behavior: "smooth" }), 100); }, [hash]);
  return (
    <>
      <PageHero eyebrow="Planear a visita" title="Informações úteis" tone="#15803d" image="/img/family.jpg">Como chegar, transportes, acessibilidade, horários, perguntas frequentes e contactos.</PageHero>
      <div className="container-x py-12 grid gap-10 lg:grid-cols-[240px_1fr]">
        <nav className="lg:sticky lg:top-24 self-start" aria-label="Nesta página">
          <ul className="flex lg:flex-col gap-2 overflow-x-auto no-scrollbar">
            {[...pages.map((p) => [p.slug, p.title]), ["perguntas", "Perguntas frequentes"]].map(([s, t]) => <li key={s} className="shrink-0"><a href={`#${s}`} className="block px-4 py-3 rounded-xl bg-white border text-sm font-semibold hover:bg-black/5" data-testid={`info-nav-${s}`}>{t}</a></li>)}
            <li className="shrink-0"><Link to="/privacidade" className="block px-4 py-3 rounded-xl text-sm underline">Privacidade</Link></li>
            <li className="shrink-0"><Link to="/cookies" className="block px-4 py-3 rounded-xl text-sm underline">Cookies</Link></li>
          </ul>
        </nav>
        <div className="grid gap-6">
          {pages.map((p) => (
            <section key={p.id} id={p.slug} className="scroll-mt-28 bg-white rounded-3xl border p-6 sm:p-8" data-testid={`info-section-${p.slug}`}>
              <h2 className="font-display text-3xl font-extrabold">{p.title}</h2>
              <Prose text={p.body} className="mt-4" />
            </section>
          ))}
          <section id="perguntas" className="scroll-mt-28 bg-white rounded-3xl border p-6 sm:p-8" data-testid="info-section-faq">
            <h2 className="font-display text-3xl font-extrabold">Perguntas frequentes</h2>
            <Accordion type="single" collapsible className="mt-4">
              <AccordionItem value="entrada"><AccordionTrigger className="text-left">A entrada é gratuita?</AccordionTrigger><AccordionContent>Sim. A entrada na Feira é livre.</AccordionContent></AccordionItem>
              <AccordionItem value="favoritos"><AccordionTrigger className="text-left">Preciso de criar conta para guardar atividades?</AccordionTrigger><AccordionContent>Não. Os favoritos ficam guardados apenas no seu dispositivo.</AccordionContent></AccordionItem>
              <AccordionItem value="app"><AccordionTrigger className="text-left">Posso instalar a plataforma no telemóvel?</AccordionTrigger><AccordionContent>Sim. No navegador do telemóvel, escolha "Adicionar ao ecrã principal" (ou "Instalar app").</AccordionContent></AccordionItem>
              {faqs.map((f) => <AccordionItem key={f.id} value={f.slug}><AccordionTrigger className="text-left">{f.title}</AccordionTrigger><AccordionContent>{f.body}</AccordionContent></AccordionItem>)}
            </Accordion>
          </section>
        </div>
      </div>
    </>
  );
}
